function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1948(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.71,
    height: 9.74,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.2175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 4.87
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.74,
    width: 22.71,
    height: 22.46,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7433333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 20.97
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32.2,
    width: 22.71,
    height: 28.49,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.542
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 46.445
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60.7,
    width: 22.71,
    height: 31.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.542
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 76.55
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 92.4,
    width: 22.71,
    height: 38.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.83875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 111.64
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 130.88,
    width: 22.71,
    height: 43.17,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.542
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 152.465
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 174.06,
    width: 22.71,
    height: 43.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 195.915
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 217.77,
    width: 22.71,
    height: 44.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.785
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 240.255
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 262.74,
    width: 22.71,
    height: 48.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.244285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 286.895
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 311.05,
    width: 22.71,
    height: 50.86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.244285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 336.48
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 361.92,
    width: 22.71,
    height: 51.4,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.542
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 387.62
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 413.31,
    width: 22.71,
    height: 53.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.83875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 439.995
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 466.69,
    width: 22.71,
    height: 55.47,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.785
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 494.425
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 522.16,
    width: 22.71,
    height: 56.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.83875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 550.625
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 579.09,
    width: 22.71,
    height: 59.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.83875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 608.745
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 638.4,
    width: 22.71,
    height: 61.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.83875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.355,
    y: 669.1999999999999
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.71,
    y: 0,
    width: 35.03,
    height: 40.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.503
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.225,
    y: 20.45
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.75,
    y: 0,
    width: 36.28,
    height: 40.9,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.046666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.89,
    y: 20.45
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.03,
    y: 0,
    width: 37.77,
    height: 40.9,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.72125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.915,
    y: 20.45
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.8,
    y: 0,
    width: 38.13,
    height: 40.9,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.4471428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.865,
    y: 20.45
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.93,
    y: 0,
    width: 38.32,
    height: 40.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.474285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.09,
    y: 20.45
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.25,
    y: 0,
    width: 39.07,
    height: 40.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.581428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.785,
    y: 20.45
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.32,
    y: 0,
    width: 39.65,
    height: 40.9,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.95625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.145,
    y: 20.45
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.97,
    y: 0,
    width: 39.69,
    height: 40.9,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.969
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 306.81500000000005,
    y: 20.45
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.66,
    y: 0,
    width: 40.5,
    height: 40.9,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 346.91,
    y: 20.45
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.16,
    y: 0,
    width: 40.99,
    height: 40.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.816666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 387.65500000000003,
    y: 20.45
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.16,
    y: 0,
    width: 41.03,
    height: 40.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 428.675,
    y: 20.45
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449.18,
    y: 0,
    width: 44.99,
    height: 40.9,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.816666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 471.675,
    y: 20.45
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.18,
    y: 0,
    width: 45.14,
    height: 40.9,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 516.75,
    y: 20.45
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.32,
    y: 0,
    width: 49.34,
    height: 40.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8428571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 563.99,
    y: 20.45
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 588.66,
    y: 0,
    width: 54.97,
    height: 40.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 616.145,
    y: 20.45
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 643.63,
    y: 0,
    width: 56.37,
    height: 40.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.8149999999999,
    y: 20.45
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.71,
    y: 40.9,
    width: 55.18,
    height: 43.69,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9718181818181817
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.3,
    y: 62.745
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.71,
    y: 84.58,
    width: 55.18,
    height: 47.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.3,
    y: 108.22999999999999
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.71,
    y: 131.88,
    width: 55.18,
    height: 47.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.326666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.3,
    y: 155.85
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.71,
    y: 179.82,
    width: 55.18,
    height: 48.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.399090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.3,
    y: 204.015
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.71,
    y: 228.22,
    width: 55.18,
    height: 48.51,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.084999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.3,
    y: 252.475
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.71,
    y: 276.73,
    width: 55.18,
    height: 50.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.3,
    y: 301.83000000000004
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.71,
    y: 326.93,
    width: 55.18,
    height: 51.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.41125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.3,
    y: 352.575
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.71,
    y: 378.22,
    width: 55.18,
    height: 52.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.5442857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.3,
    y: 404.625
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.71,
    y: 431.03,
    width: 55.18,
    height: 53.07,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.581428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.3,
    y: 457.565
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.71,
    y: 484.1,
    width: 55.18,
    height: 64.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.196666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.3,
    y: 516.45
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.71,
    y: 548.8,
    width: 55.18,
    height: 74.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.518
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.3,
    y: 586.28
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.71,
    y: 623.76,
    width: 55.18,
    height: 76.24,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.8975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.3,
    y: 661.88
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.9,
    y: 40.9,
    width: 60.85,
    height: 79.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.141666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.325,
    y: 80.53
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.74,
    y: 40.9,
    width: 67.45,
    height: 79.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4944444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.465,
    y: 80.53
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.19,
    y: 40.9,
    width: 71.04,
    height: 79.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.840000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.71,
    y: 80.53
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.23,
    y: 40.9,
    width: 71.25,
    height: 79.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 312.855,
    y: 80.53
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.48,
    y: 40.9,
    width: 72.28,
    height: 79.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.325714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 384.62,
    y: 80.53
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.76,
    y: 40.9,
    width: 73.19,
    height: 79.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.14875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 457.355,
    y: 80.53
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.96,
    y: 40.9,
    width: 97.69,
    height: 79.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 542.805,
    y: 80.53
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 591.65,
    y: 40.9,
    width: 108.35,
    height: 79.26,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.322857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 645.8249999999999,
    y: 80.53
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.9,
    y: 120.16,
    width: 108.13,
    height: 103.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.206666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.965,
    y: 171.78
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.9,
    y: 223.4,
    width: 108.13,
    height: 114.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.51625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.965,
    y: 280.86
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.9,
    y: 338.31,
    width: 108.13,
    height: 167.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.021666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.965,
    y: 421.865
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.9,
    y: 505.42,
    width: 108.13,
    height: 194.58,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.021666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.965,
    y: 602.71
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.03,
    y: 120.16,
    width: 114.96,
    height: 199.94,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.450909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.51,
    y: 220.13
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.99,
    y: 120.16,
    width: 152.1,
    height: 199.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 38.025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.04,
    y: 220.13
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.09,
    y: 120.16,
    width: 246.91,
    height: 199.94,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.988
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.545,
    y: 220.13
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.03,
    y: 320.09,
    width: 287.68,
    height: 176.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 29.391666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.87,
    y: 408.265
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.03,
    y: 496.44,
    width: 287.68,
    height: 203.56,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.87,
    y: 598.22
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.7,
    y: 320.09,
    width: 226.3,
    height: 379.91,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 45.260000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 586.85,
    y: 510.04499999999996
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1948);
export default __webpack_public_path__ + "static/media/1948.c75fbbf04f269c4c95519bae22df9416.svg";
export { ForwardRef as ReactComponent };